/* HT fix 2026-08-10 (Claude): los iconos de las 12 lineas de producto dentro del menu movil
   (#htMobileNav / .ht-mobile-nav-drawer) tienen loading="lazy", pero ese contenedor arranca
   con display:none hasta que el cliente toca el boton hamburguesa. El lazy-load nativo del
   navegador depende de que el elemento tenga una caja de layout real; con display:none nunca
   la tiene, asi que el navegador nunca dispara la carga. Confirmado en vivo: 12 imagenes
   quedaban permanentemente sin cargar. Este archivo vive en assets/ y se referencia desde
   snippets/header-scripts.liquid (NO en layout/theme.liquid) porque la app Yoast SEO
   sobreescribe theme.liquid periodicamente y borra ediciones manuales inline -- confirmado en
   vivo el 2026-08-10 (un primer intento de este mismo fix, escrito directo en theme.liquid,
   desaparecio solo del HTML renderizado en cuestion de horas). Un archivo de asset aparte no
   le importa a Yoast y sobrevive esos syncs. */
(function () {
  function htFixHiddenNavImages() {
    var imgs = document.querySelectorAll(
      '.ht-mobile-nav-drawer img[loading="lazy"], #htMobileNav img[loading="lazy"]'
    );
    imgs.forEach(function (img) {
      img.loading = 'eager';
      if (img.dataset && img.dataset.src && (!img.src || img.src.indexOf('data:') === 0)) {
        img.src = img.dataset.src;
      }
      if (img.dataset && img.dataset.srcset && !img.srcset) {
        img.srcset = img.dataset.srcset;
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', htFixHiddenNavImages);
  } else {
    htFixHiddenNavImages();
  }
})();
